module.exports = __webpack_public_path__ + "static/media/gianlucadibella.409596e8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/gianlucadibella.webp
// module id = 662
// module chunks = 0